var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7155 32.6941L23.0946 16.0732C24.7384 11.8723 23.8252 6.94088 20.3549 3.47058C16.7019 -0.182358 11.2225 -0.912946 6.83899 1.09617L14.6928 8.95L9.2134 14.4294L1.17693 6.57558C-1.01484 10.9591 -0.101601 16.4385 3.55134 20.0915C7.02163 23.5618 11.9531 24.475 16.154 22.8312L32.7749 39.4521C33.5055 40.1826 34.6013 40.1826 35.3319 39.4521L39.5328 35.2512C40.446 34.5206 40.446 33.2421 39.7155 32.6941Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVm);
export default __webpack_public_path__ + "static/media/vm.7de6ff32db2f11df2c023354b544be34.svg";
export { ForwardRef as ReactComponent };